module.exports = __webpack_public_path__ + "assets/img/footer_logo_0.c9c68c56.png";